import React, { useEffect } from 'react';
import proptypes from 'prop-types';
import {
  arrayOf,
  params,
  shape,
  string as stringType,
  useDataModel
} from '@thd-nucleus/data-sources';
import { Skeleton, SkeletonBlock, Typography } from '@one-thd/sui-atomic-components';
import { withDynamicComponent } from '@thd-nucleus/app-render';
import { withHydrator } from '@thd-olt-component-react/hydrator';
import { StoreInfo } from './StoreInfo/StoreInfo';

const { string } = proptypes;

const StateDirectoryComponent = ({ state }) => {
  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('state-directory.ready'); }, []);

  const { data, loading, error } = useDataModel('storeDirectoryByState', {
    variables: { state }
  });

  const storesInfo = data?.storeDirectoryByState?.storesInfo || [];
  const stateName = data?.storeDirectoryByState?.stateName || '';

  if (loading) {
    return (
      <article data-component="StateDirectoryPlaceholder">
        <Skeleton SkeletonContentProps={{ disablePadding: true }} grow>
          <SkeletonBlock aspect="wide" height="700px" />
        </Skeleton>
      </article>
    );
  }
  if (!storesInfo?.length || error) return null;

  return (
    <article data-component="StateDirectory">
      <section>
        <Typography variant="h1" weight="display">
          {stateName} Stores
        </Typography>
      </section>
      <section className="sui-columns-2 sui-p-4 md:sui-columns-3 lg:sui-columns-6 lg:sui-gap-10">
        {storesInfo.map((store, storeIndex) => <StoreInfo store={store} key={storeIndex} id={storeIndex} />)}
      </section>
    </article>
  );
};

const propTypes = {
  state: string.isRequired
};

StateDirectoryComponent.displayName = 'State Directory';

const dataModel = {
  storeDirectoryByState: params({ state: stringType().isRequired() }).shape({
    stateName: stringType(),
    storesInfo: arrayOf(shape({
      storeName: stringType(),
      url: stringType(),
      phone: stringType(),
      rentalsLink: stringType(),
      servicesLink: stringType(),
      address: shape({
        street: stringType(),
        city: stringType(),
        state: stringType(),
        postalCode: stringType(),
        county: stringType()
      })
    }))
  })
};
StateDirectoryComponent.dataModel = dataModel;
StateDirectoryComponent.propTypes = propTypes;

const HydratedComponent = withHydrator({
  delay: 500,
  id: 'state-directory',
  placeholder: (
    <div data-component="StateDirectoryPlaceholder">
      <Skeleton SkeletonContentProps={{ disablePadding: true }} grow>
        <SkeletonBlock aspect="wide" height="750px" />
      </Skeleton>
    </div>
  ),
  scrollBuffer: 100,
}, StateDirectoryComponent);

const StateDirectory = withDynamicComponent(HydratedComponent);

StateDirectory.dataModel = dataModel;
StateDirectory.propTypes = propTypes;

export { StateDirectory };
